"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./TextArea.style"));

var TextArea = react_1.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      name = _ref.name,
      onChange = _ref.onChange,
      maxLength = _ref.maxLength,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      _ref$invalidCaption = _ref.invalidCaption,
      invalidCaption = _ref$invalidCaption === void 0 ? '' : _ref$invalidCaption,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$full = _ref.full,
      full = _ref$full === void 0 ? false : _ref$full;

  function handleOnChange(_ref2) {
    var target = _ref2.target;
    onChange && onChange(target.value);
  }

  return jsx_runtime_1.jsxs("div", Object.assign({
    className: className,
    css: [styles.container, full && styles.full]
  }, {
    children: [jsx_runtime_1.jsx("textarea", {
      ref: ref,
      css: [styles.textAreaWrapper, invalid && styles.invalid, full && styles.full],
      name: name,
      onChange: handleOnChange,
      disabled: disabled,
      maxLength: maxLength,
      defaultValue: defaultValue,
      placeholder: placeholder
    }, void 0), invalid && invalidCaption && jsx_runtime_1.jsx("div", Object.assign({
      css: [styles.caption, styles.invalidCaption]
    }, {
      children: invalidCaption
    }), void 0)]
  }), void 0);
});
exports.default = react_1.memo(TextArea);